import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NzBadgeModule } from "ng-zorro-antd/badge";
import { DynamicRoundPipe } from "src/app/core/pipes/dynamic-round.pipe";
import { MyAddressesComponent } from "src/app/main/my-account/components/my-addresses/my-addresses.component";
import { ProductCardComponent } from "src/app/main/products/components/product-card/product-card.component";
import { environment } from "src/environments/environment";
import { StarComponent } from "../components/star/star.component";
import { PrimeNGUIModule } from "./primeng-ui.module";
import { ZorroModule } from "./zorro.module";
import {SkeletonModule} from 'primeng/skeleton';
import { CarouselModule } from "ngx-owl-carousel-o";
import { SkeltonComponent } from "../components/star/skelton/skelton.component";
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { ProductNamePipe } from "src/app/core/pipes/product-name.pipe";
import { ThemeLoaderDirective } from "src/app/core/directives/themes-loader.directive";
import { SharedModule as lib_shared } from "imakeapp-shared";
import { MobileThemeLoaderDirective } from "src/app/core/directives/mobile-themes-loader.directive";
import { MyLanguageComponent } from "src/app/main/my-account/components/my-language/my-language.component";



@NgModule({
    declarations: [
        StarComponent,
        ProductCardComponent,
        MyAddressesComponent,
        MyLanguageComponent,
        DynamicRoundPipe,
        SkeltonComponent,
        ProductNamePipe,
        ThemeLoaderDirective,
    ],
    imports: [
        CommonModule,

        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        ZorroModule,
        NzBadgeModule,
        PrimeNGUIModule,
        SkeletonModule,
        CarouselModule,
        LazyLoadImageModule,
        lib_shared
    ],
    exports : [
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        StarComponent,
        NzBadgeModule,
        ProductCardComponent,
        PrimeNGUIModule,
        ZorroModule,
        MyAddressesComponent,
        DynamicRoundPipe,
        SkeletonModule,
        CarouselModule,
        SkeltonComponent,
        ProductNamePipe,
        ThemeLoaderDirective,
    ],
    providers:[
    ]
})
export class SharedModule {}
